<template>
	<div :class="formFieldClass" class="form-field--select">
		<label :for="name" v-html="label"/>
		<div class="form-field--select__search">
			<input
				v-model="search"
				type="text" @click="showOptions()" v-on:keydown.enter.prevent/>
			<button @click.prevent="clearSelection()">Clear</button>
		</div>
		<input
			:id="name"
			:disabled="disabled"
			:name="name"
			:value="value" class="sr-only form-field--select__input" readonly
			type="text" @input="onInput"/>
		<div v-if="shouldShowOptions" class="form-field--select__options">
			<p v-if="!validOptions.length">No valid options</p>
			<ul v-else class="form-field--select__options__list">
				<li
					class="form-field--select__options__list__item"
					@click.prevent="select('')">
					<span>—</span>
				</li>
				<li
					v-for="(option, optionIndex) in validOptions" :key="optionKey(option, optionIndex)"
					class="form-field--select__options__list__item"
					@click.prevent="select(optionValue(option, optionIndex))">
					<span v-html="optionLabel(option, optionIndex)"/>
				</li>
			</ul>
		</div>
		<div class="help-block">
			<slot name="helpBlock"/>
		</div>
		<div class="error-block">
			<slot name="errorBlock">
				<p v-if="error" v-html="error"/>
			</slot>
		</div>
	</div>
</template>
<style>
.form-field--select--open input {
	border-radius: .5em .5em 0 0;
}

.form-field--select__search {
	position: relative;
}

.form-field--select__search button {
	position: absolute;
	top: 0;
	right: 1em;
	bottom: 0;
	margin: auto;
}

.form-field--select__options {
	border: 1px solid pink;
	border-radius: 0 0 .5em .5em;
}
</style>
<script>

export default {
	name: "FormFieldSelect",
	data() {
		return {
			shouldShowOptions: false,
			searchEnabled: false,
			search: "",
		};
	},
	computed: {
		formFieldClass() {
			return {
				"form-field--select--disabled": this.disabled,
				"form-field--select--open": this.shouldShowOptions,
			};
		},
		validOptions() {
			if (!this.searchEnabled) {
				return this.options;
			}
			if (!this.search.length) {
				return this.options;
			}
			return _.filter(this.options, (option, optionIndex) => {
				return this.optionLabel(option, optionIndex).toLowerCase().startsWith(this.search.toLowerCase());
			});
		},
	},
	props: {
		label: {
			required: true,
			type: String,
		},
		name: {
			required: true,
			type: String,
		},
		id: {
			type: String,
		},
		value: {
			required: true,
			type: String,
		},
		disabled: {
			required: false,
			type: Boolean,
			default() {
				return false;
			},
		},
		nullable: {
			required: false,
			type: Boolean,
			default() {
				return true;
			},
		},
		options: {
			required: true,
			type: Array,
		},
		optionKey: {
			required: false,
			type: Function,
			default: (option, optionIndex) => {
				return optionIndex;
			},
		},
		optionLabel: {
			required: false,
			type: Function,
			default: (option, optionIndex) => {
				return option;
			},
		},
		optionValue: {
			required: false,
			type: Function,
			default: (option, optionIndex) => {
				return option;
			},
		},
		error: {
			required: false,
			type: String,
			default() {
				return null;
			},
		},
	},
	methods: {
		showOptions() {
			this.shouldShowOptions = true;
			this.searchEnabled = false;
			window.addEventListener("keyup", this.onEscKeyUp);
		},
		hideOptions() {
			this.shouldShowOptions = false;
			window.removeEventListener("keyup", this.onEscKeyUp);
		},
		clearSelection() {
			this.search = "";
			this.select();
			this.hideOptions();
		},
		select(value = "") {
			this.$emit("input", value);
			this.hideOptions();
		},
		setSearchValue() {
			let optionKey = _.findKey(this.options, (option, optionIndex) => {
				return this.optionValue(option, optionIndex) === this.value;
			});
			this.search = optionKey ? this.optionLabel(this.options[optionKey], optionKey) : "";
		},
		onInput() {
			this.$emit("input", !this.value);
		},
		onEscKeyUp(event) {
			// this.hideOptions();
			// event.preventDefault();
			// event.stopImmediatePropagation();
		},
	},
	created() {
		this.setSearchValue();
		window.addEventListener("click", (e) => {
			if (!this.$el.contains(e.target)) {
				this.hideOptions();
			}
		});
	},
	watch: {
		search() {
			this.searchEnabled = true;
		},
		value() {
			this.setSearchValue();
		},
	},
};
</script>
